if (!customElements.get('lynks-mobile-purchase')) {
  customElements.define('lynks-mobile-purchase', class extends HTMLElement {
    connectedCallback() {
      this.info = this.closest('product-info');
      this.form = document.getElementById(this.dataset.formId);
      this.primary = this.form?.querySelector('button[name="add"]');
      this.button = this.querySelector('[data-purchase-button]');
      if (!this.info || !this.primary || !window.IntersectionObserver) return;
      this.variants = JSON.parse(this.querySelector('[data-purchase-variants]').textContent);
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.controller = new AbortController();
      this.update = this.sync.bind(this);
      this.passedPrimary = false;
      this.footerVisible = false;
      this.intersections = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.target === this.primary) this.passedPrimary = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
          else this.footerVisible = entry.isIntersecting;
        }
        this.sync();
      });
      this.intersections.observe(this.primary);
      const footer = document.querySelector('footer');
      if (footer) this.intersections.observe(footer);
      this.stateObserver = new MutationObserver(this.update);
      this.stateObserver.observe(this.primary, { attributes: true, childList: true, subtree: true, characterData: true });
      this.overlayObserver = new MutationObserver(this.update);
      for (const overlay of document.querySelectorAll('cart-notification,#cart-notification,cart-drawer,product-modal,dialog,.menu-drawer-container,details-modal details')) {
        this.overlayObserver.observe(overlay, { attributes: true, attributeFilter: ['class', 'open'] });
      }
      const options = { signal: this.controller.signal };
      this.info.addEventListener('input', this.update, options);
      this.info.addEventListener('change', this.update, options);
      this.mobile.addEventListener('change', this.update, options);
      window.visualViewport?.addEventListener('resize', this.update, options);
      document.addEventListener('fullscreenchange', this.update, options);
      document.addEventListener('focusin', this.update, options);
      document.addEventListener('focusout', () => requestAnimationFrame(this.update), options);
      if (typeof subscribe === 'function') {
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId === this.dataset.sectionId) this.sync();
        });
        this.unsubscribeError = subscribe(PUB_SUB_EVENTS.cartError, ({ productVariantId }) => {
          if (String(productVariantId) !== this.form.querySelector('[name="id"]').value) return;
          queueMicrotask(() => {
            const error = this.info.querySelector('.product-form__error-message-wrapper');
            if (!error || error.hidden) return;
            error.setAttribute('tabindex', '-1');
            error.focus();
            error.scrollIntoView({ block: 'center' });
          });
        });
      }
      this.sync();
    }
    sync() {
      const variantId = this.form.querySelector('[name="id"]')?.value;
      const variant = this.variants.find((item) => String(item.id) === variantId);
      if (variant) {
        this.querySelector('[data-purchase-style]').textContent = variant.title;
        this.querySelector('[data-purchase-price]').textContent = variant.price;
      }
      this.querySelector('[data-purchase-quantity]').textContent = this.form.elements.namedItem('quantity')?.value || '1';
      this.button.disabled = this.primary.disabled || this.primary.getAttribute('aria-disabled') === 'true' || !variant;
      this.button.querySelector('span').textContent = this.primary.querySelector('span')?.textContent.trim() || window.variantStrings.addToCart;
      this.button.setAttribute('aria-busy', String(this.primary.classList.contains('loading')));
      const overlay = document.querySelector('#cart-notification.active,cart-notification.active,cart-drawer.active,product-modal[open],dialog[open],.menu-drawer-container[open],details-modal details[open]');
      const typing = document.activeElement?.matches('input:not([type="radio"]):not([type="checkbox"]),textarea,select');
      this.hidden = !this.mobile.matches || !this.passedPrimary || this.footerVisible || !!overlay || !!typing || !!document.fullscreenElement;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.intersections?.disconnect();
      this.stateObserver?.disconnect();
      this.overlayObserver?.disconnect();
      this.unsubscribeVariant?.();
      this.unsubscribeError?.();
    }
  });
}
